import { useEffect, useRef } from "react";
import { usePublicConfig } from "../lib/session";

declare global {
  interface Window {
    turnstile?: { render: (el: HTMLElement, opts: { sitekey: string; callback: (t: string) => void; "expired-callback"?: () => void }) => string; remove: (id: string) => void };
  }
}

/** Cloudflare Turnstile widget (AUTH-1). Renders nothing when the environment has no site key (local dev). */
export function Turnstile({ onToken }: { onToken: (token: string | undefined) => void }) {
  const cfg = usePublicConfig();
  const ref = useRef<HTMLDivElement>(null);
  const siteKey = cfg.data?.turnstileSiteKey;
  useEffect(() => {
    if (!siteKey || !ref.current) return;
    let id: string | undefined;
    const render = () => {
      if (ref.current && window.turnstile) id = window.turnstile.render(ref.current, { sitekey: siteKey, callback: onToken, "expired-callback": () => onToken(undefined) });
    };
    if (window.turnstile) render();
    else {
      const s = document.createElement("script");
      s.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
      s.async = true;
      s.onload = render;
      document.head.appendChild(s);
    }
    return () => {
      if (id && window.turnstile) window.turnstile.remove(id);
    };
  }, [siteKey, onToken]);
  return siteKey ? <div ref={ref} className="mb-4" /> : null;
}
